export default __webpack_public_path__ + "static/media/pubg.5a6540f5.png";